import { useMemo, useState } from 'react';

// MUI Theme
import { getCoreRowModel } from '@tanstack/react-table';
import { Paper, Box, Button, Typography } from '@mui/material';
import { FileUploadOutlined } from '@mui/icons-material';

// Common components
import { useNewTable, Table } from '../../../components/common/table';
import { AuthGuard } from '../../common/AuthGuard';

// Utils
import { makeUserGuideColumns } from '../../../utils/columns/makeUserGuideColumns';
import { downloadUserGuide, getUserGuides } from '../../../services/userGuide.service';

// Permissions
import { AppPermissions } from '../../../constants/Permissions';

// Types
import { UserGuideType } from '../../../types/UserGuideTypes';

import { UploadUserGuideModal } from './UploadUserGuideModal';
import { tablePrimaryButtonSx } from '../../../styles/tableButtonStyles';

const UserGuide = () => {
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [paramFilter, setParamFilter] = useState<any>({});

  const forceReload = () => setParamFilter({ ...paramFilter, changedAt: new Date() });

  const handleClickDownload = (guide: any) => {
    downloadUserGuide(guide.fileName);
  };

  const columns = useMemo(() => makeUserGuideColumns(handleClickDownload), []);
  const table = useNewTable<UserGuideType>({
    columns,
    fetchAsync: getUserGuides,
    serverSide: true,
    shouldFetch: true,
    params: paramFilter,
  });

  return (
    <>
      <Paper sx={{ p: 1.5 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: { xs: 'flex-start', md: 'center' },
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            rowGap: 1,
            columnGap: 1.5,
            mb: 1.5,
            px: { xs: 0.5, sm: 0.75 },
          }}
        >
          <Typography variant='h6' sx={{ m: 0, fontWeight: 700, color: '#1f2d63' }}>
            User Guides
          </Typography>

          <AuthGuard permission={AppPermissions.UserGuide.Manage}>
            <Button
              variant='contained'
              size='small'
              onClick={() => setIsUploadModalOpen(true)}
              endIcon={<FileUploadOutlined />}
              sx={tablePrimaryButtonSx}
            >
              Upload User Guide
            </Button>
          </AuthGuard>
        </Box>

        <Table {...table} showSearchBar={false} showColumnToggler={false} getCoreRowModel={getCoreRowModel()} />
      </Paper>

      {isUploadModalOpen && <UploadUserGuideModal setModalOpen={setIsUploadModalOpen} forceReloadTable={forceReload} />}
    </>
  );
};

export default UserGuide;
